function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.032,0,0,0.032,0,6)",
    stroke: "none",
    style: {
      fill: "#95a5a6"
    },
    d: "M 807 537 C 725 537 658 470 658 389 C 658 354 670 323 690 297 C 725 345 770 390 802 405 C 805 406 808 407 811 407 C 819 407 827 402 831 394 C 836 383 831 369 820 364 C 794 352 753 309 723 266 C 747 250 776 240 807 240 C 889 240 955 307 955 389 C 955 470 889 537 807 537 M 521 360 C 518 360 515 359 513 359 C 511 359 510 360 508 360 L 385 181 L 626 181 z M 192 537 C 110 537 44 470 44 389 C 44 307 110 240 192 240 C 214 240 235 245 254 254 L 179 371 C 175 378 175 386 178 393 C 181 400 188 404 195 405 L 337 421 C 322 487 263 537 192 537 M 340 376 L 236 365 L 291 278 C 319 303 337 337 340 376 M 343 197 L 468 380 C 466 383 464 386 462 390 L 385 381 C 383 325 356 274 315 240 z M 807 196 C 767 196 729 208 699 229 C 689 212 683 197 683 187 L 683 172 L 684 170 C 688 163 688 154 684 147 C 684 147 684 146 683 146 L 683 22 C 683 16 681 10 676 6 C 671 1 664 0 658 1 L 575 13 C 562 15 554 26 556 38 C 558 50 569 59 581 57 L 639 48 L 639 136 L 357 136 L 349 118 L 382 118 C 395 118 405 108 405 96 C 405 84 395 74 382 74 L 253 74 C 241 74 231 84 231 96 C 231 108 241 118 253 118 L 300 118 L 317 155 L 278 216 C 252 203 223 196 192 196 C 86 196 0 282 0 389 C 0 495 86 581 192 581 C 286 581 364 514 381 426 L 457 434 C 464 458 486 476 513 476 C 545 476 571 450 571 418 C 571 405 566 393 559 383 L 649 229 C 654 238 659 248 665 259 C 633 293 614 339 614 389 C 614 495 700 581 807 581 C 913 581 1000 495 1000 389 C 1000 282 913 196 807 196"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeIcon);
export default __webpack_public_path__ + "static/media/bike-icon.77b2c17e2444f0ce310605bf7c93b133.svg";
export { ForwardRef as ReactComponent };